import useSWR from "swr";
import { NormasTeachingCouponDTO } from "./useNormasTeachingCouponById.ts";
import { useCreateProductServicePublicAxiosInstance } from "../../Auth/useCreateProductServicePublicAxiosInstance.ts";

export function useAllNormasTeachingCoupons() {
  const { createAxiosInstance } = useCreateProductServicePublicAxiosInstance();
  const { data, isLoading } = useSWR(`/coupons`, async (url) => {
    const { data } = await createAxiosInstance().get<{
      coupons: NormasTeachingCouponDTO[];
    }>(url);

    return data;
  });

  return {
    coupons: data?.coupons ?? [],
    isLoading: isLoading,
  };
}
